/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

nve-page-panel:has(nve-page-panel-header) {
  &::part(_header) {
    border-bottom: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color);
  }
}

nve-page-panel-header:has(nve-tabs) {
  --padding: var(--nve-ref-size-200) var(--nve-ref-size-300);
}
